export const LithiumMetalBatteriesContainedInEquipment = 'LithiumMetalBatteriesContainedInEquipment';
export const LithiumMetalBatteriesPackedWithEquipment = 'LithiumMetalBatteriesPackedWithEquipment';
export const LithiumMetalBatteriesStandAlone = 'LithiumMetalBatteriesStandAlone';
export const LithiumIonBatteriesContainedInEquipment = 'LithiumIonBatteriesContainedInEquipment';
export const LithiumIonBatteriesPackedWithEquipment = 'LithiumIonBatteriesPackedWithEquipment';
export const LithiumIonBatteriesStandAlone = 'LithiumIonBatteriesStandAlone';
export const LimitedQuantity = 'LimitedQuantity';
export const SmallQuantityProvision = 'SmallQuantityProvision';
